import  React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png";
import training4 from "../static/img/training11.png";
import training1 from "../static/img/training12.png";
import training3 from "../static/img/training13.png";
import training2 from "../static/img/training14.png";
//import training5 from "../static/img/training5.jpg";
//import training6 from "../static/img/training6.jpg";

import "./Microcredit.style.scss";

const OnlineTraining2026: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on: false, index: 0});
    const [en, setEn] = useState(false);
    return (
        <div style={{marginTop:"30px",marginBottom:"20px"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",marginBottom:"50px"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>
            <h1>
                {en ? "Online training for authors of microcredit programs from Ukraine" : 
                "Онлайн-тренінг для авторів програм мікрокредитування з України"}
            </h1>
            <p style={{fontWeight:"inherit",fontSize: "20px",margin:"30px 120px 30px 120px",textAlign:"left"}}>
                {en ? (<>
                        &nbsp; &nbsp;On January 29, 2026, an online meeting of DOMANI project partners was held to discuss the structure of
                        microcredit program syllabi and the structure of distance learning courses being developed in the LSM Moodle system.
                        The event was co-organized by NGO ‘Ukrainian Joint Meteorological and Hydrological Society’ (UMHS, Odesa)
                        and V. N. Karazin Kharkiv National University.<br/>
                        &nbsp; &nbsp;The main speaker Oleh Shablii from UMHS presented the Guidelines for Development of e-Courses
                        and the newly developed syllabus for the course devoted to Eco-Communication Strategies.
                        In addition, there was an active discussion on the issues related to preparation and structure of
                        microcredit syllabi, the project website content and coordination of the following joint activities.
                        The total number of participants comprised 23.
                    </>)
                    :
                    (<>
                        &nbsp; &nbsp;29 січня 2026 року відбулась онлайн зустріч партнерів проєкту DOMANI для обговорення структури Силабусів
                        мікрокредитних програм і структури дистанційних курсів, що формуються в системі LSM Moodle.  Захід був спільно
                        організований ГО «Українське об'єднане метеорологічне та гідрологічне товариство» (УОМГТ, Одеса) та Харківським
                        національним університетом імені В. Н. Каразіна.<br/>
                        &nbsp; &nbsp;Головний доповідач Олег Шаблій з УОМГТ представив своє бачення на Керівні принципи розробки електронних курсів
                        та нещодавно розроблену програму курсу, присвяченого стратегіям екокомунікації. Крім того, відбулася активна
                        дискусія з питань, пов'язаних з підготовкою та структурою програм мікрокредитування, змістом веб-сайту проекту
                        та координацією наступних спільних заходів. Загальна кількість учасників зустрічі – 23.
                    </>)
                }
            </p>
            {/*<p style={{textIndent: "2em"}}>*/}
            {/*    This is the second paragraph, which starts on a new line and also has an indent.*/}
            {/*</p>*/}
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px',width:"84%",margin:"0 auto"}}>
                <img src={training1} alt="training" style={{ width: '100%' }} />
                <img src={training2} alt="training" style={{ width: '100%',height:'100%' }} />
                <img src={training3} alt="training" style={{ width: '100%',height:'90%' }} />
                <img src={training4} alt="training" style={{ width: '100%',height:'90%' }} />
                {/*/!* <img src={training5} alt="training" style={{ width: '100%' }} />*/}
                {/*<img src={training6} alt="training" style={{ width: '100%' }} /> *!/*/}
            </div>
        </div>
    )
}
export default OnlineTraining2026;